import { useEffect, useState, useCallback } from "react";
import { IndianRupee, RefreshCw } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/ui-helpers";
import { toast } from "sonner";

const CARDS = [
  ["gmv", "GMV (₹)"], ["orders", "Orders"], ["avg_order_value", "Avg order (₹)"],
  ["gross_sales", "Gross sales (₹)"], ["discounts", "Discounts (₹)"], ["taxable_sales", "Taxable (₹)"],
  ["tax_collected", "Tax collected (₹)"], ["shipping", "Shipping (₹)"], ["commission", "Commission (₹)"],
  ["refunds", "Refunds (₹)"], ["net_sales", "Net sales (₹)"],
];

export default function AdminFinance() {
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    api.get("/marketplace/admin/finance/overview").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e?.response?.data?.detail)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const t = data?.totals || {};
  return (
    <div className="mx-auto max-w-5xl">
      <PageHeader title="Financial Overview" icon={IndianRupee}
        subtitle="Marketplace-wide financials from canonical order records — server-calculated, immutable and audited. Separate from subscription accounting."
        actions={<button onClick={load} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-600" data-testid="admin-finance-refresh"><RefreshCw className="h-4 w-4" /> Refresh</button>} />

      <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-testid="admin-finance-totals">
        {CARDS.map(([k, l]) => (
          <div key={k} className="card-soft p-4"><p className="text-xs text-slate-500">{l}</p><p className={`text-xl font-bold ${k === "refunds" && t[k] ? "text-rose-600" : "text-slate-800"}`}>{(t[k] ?? 0).toLocaleString()}</p></div>
        ))}
      </div>

      {data?.note && <p className="mb-4 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-500">{data.note}</p>}

      <div className="card-soft overflow-x-auto p-0" data-testid="admin-finance-sellers">
        <table className="w-full min-w-[520px] text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-400"><tr><th className="p-3">Seller</th><th className="p-3 text-center">Orders</th><th className="p-3 text-right">Gross (₹)</th><th className="p-3 text-right">Tax (₹)</th><th className="p-3 text-right">Commission (₹)</th></tr></thead>
          <tbody>
            {(data?.sellers || []).map((s) => (
              <tr key={s.seller_id} className="border-t border-slate-100"><td className="p-3 font-mono text-xs text-slate-600">{(s.seller_id || "").slice(0, 12)}…</td><td className="p-3 text-center">{s.orders}</td><td className="p-3 text-right font-semibold">{s.gross.toLocaleString()}</td><td className="p-3 text-right text-slate-600">{s.tax.toLocaleString()}</td><td className="p-3 text-right text-slate-600">{s.commission.toLocaleString()}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
